import { createMemo } from '@packages/react';
import { castArray, each } from 'lodash';
import React, { useEffect } from 'react';
import { Route as ReactRoute, Switch as ReactSwitch } from 'react-router';
import { app } from '../../app';
import { RouterServiceProvider } from './RouterServiceProvider';

/**
 * Get url of a route
 * @param name
 * @param params
 * @returns {string}
 */
export function route(name: string, params?: { [name: string]: any }): string {
    return app(RouterServiceProvider).route(name, params);
}

/**
 * Register a route
 * @param name
 * @param url
 */
export function registerRoute(name: string | string[], url: string): void {
    app(RouterServiceProvider).register(name, url);
}

interface RouteProps {
    path: string;
    customPath?: string;
    name?: string;
    alias?: string;

    component?: any;
    render?: () => any;
    children?: () => any;

    exact?: boolean;
    sensitive?: boolean;
    strict?: boolean;
}

/**
 * 'Frontend' of our router register
 * @param props
 * @returns {*}
 * @constructor
 */
export const Route = (props: RouteProps) => {
    const { name, alias, customPath, path, ...rest } = props;

    return <ReactRoute path={path} {...rest} />;
};

Route.displayName = 'core(Route)';

interface SwitchProps {
    children: any;
}

const childrenRouteRegister = (children) => {
    each(castArray(children), (child) => {
        if (child && (child.type === Route || Array.isArray(child))) {
            if (Array.isArray(child)) {
                childrenRouteRegister(child);
                return;
            }
            const { name, alias, path, customPath } = child.props || {};

            const path$ = customPath || path;

            if (path$) {
                if (name) {
                    registerRoute(name, path$);
                }

                if (alias) {
                    registerRoute(alias, path$);
                }
            }
        }
    });
};

export const Switch = createMemo<SwitchProps>(
    ({ children, ...rest }) => {
        useEffect(() => {
            childrenRouteRegister(children);
        }, ['']);

        return <ReactSwitch {...rest}> {children} </ReactSwitch>;
    },
    {
        displayName: 'core(Switch)',
    },
);
